import { useUiStore } from '@/features/settings/ui-store.js';
import { skillsQueryOptions } from '@/lib/api/skills.js';

/**
 * The skills query scoped to a workspace — private + corporate plus that workspace's own skills.
 * Every surface that offers skills for use (the directory pane, the composer chips, the slash menu)
 * reads it through this hook, so they always agree on which workspace's skills are on the table and
 * switch together when the workspace switcher moves.
 *
 * `override` targets a specific workspace instead of the switcher's selection — the workspace
 * manage page opens the directory for the workspace being MANAGED, which may not be the selected
 * one (the same reason `ConnectorsTab` passes its id explicitly).
 */
export function useSelectedWorkspaceSkillsQuery(override?: string | null) {
  const selectedWorkspaceId = useUiStore((state) => state.selectedWorkspaceId);
  return skillsQueryOptions(
    override === undefined ? selectedWorkspaceId : override,
  );
}
